
import { Component, Vue } from "vue-property-decorator";
import { USER_GETTERS } from "@/store/user/getters";
import { User } from "@/store/user/types";

@Component
export default class ChatbotFab extends Vue {
  chatbotVisible = false;
  drawerDismissed = false;

  get user(): User {
    return this.$store.getters[USER_GETTERS.ACTING_USER];
  }

  get isAuthenticated(): boolean {
    return this.$store.getters[USER_GETTERS.IS_AUTHENTICATED];
  }

  get isOnLoginPage(): boolean {
    return this.$route.path === '/login';
  }

  get shouldShowChatbot(): boolean {
    // Don't show chatbot for admins (when authenticated and not on login page)
    if (this.isAuthenticated && !this.isOnLoginPage && this.user?.type?.toLowerCase() === 'admin') {
      return false;
    }
    return true;
  }

  get chatbotSrc(): string {
    // Default chatbot for login page or non-authenticated users
    const defaultChatbot = "https://udify.app/chatbot/yD4Iq7OIDp9IKTmC";
    
    if (!this.isAuthenticated || this.isOnLoginPage) {
      return defaultChatbot;
    }

    // Dynamic chatbot selection based on user type or other criteria
    return this.getChatbotForUser();
  }

  getChatbotForUser(): string {
    if (!this.user) {
      return "https://udify.app/chatbot/yD4Iq7OIDp9IKTmC";
    }

    // Chatbot assignment based on user type
    switch (this.user.type?.toLowerCase()) {
      case 'coach':
        return "https://udify.app/chatbot/jpgDOEHYhsYafqS9?name=$";
      case 'participant':
        return "https://udify.app/chatbot/yD4Iq7OIDp9IKTmC"; // Same as default
      default:
        return "https://udify.app/chatbot/yD4Iq7OIDp9IKTmC"; // Default fallback
    }
  }

  openChatbot() {
    this.chatbotVisible = true;
  }

  closeChatbot() {
    this.chatbotVisible = false;
  }

  dismissDrawer() {
    this.drawerDismissed = true;
    this.chatbotVisible = false;
  }

  // Optional: Close chatbot when clicking outside
  mounted() {
    document.addEventListener('keydown', this.handleEscapeKey);
  }

  beforeDestroy() {
    document.removeEventListener('keydown', this.handleEscapeKey);
  }

  handleEscapeKey(event: KeyboardEvent) {
    if (event.key === 'Escape' && this.chatbotVisible) {
      this.closeChatbot();
    }
  }
}
